import {
  formatDurationToHoursMinutesAndSeconds,
  formatDurationToMinutesAndSeconds,
} from "V2.0/utils";
import StatCard from "./Components/StatCard";
import { ChartPieIcon, ClockIcon } from "@heroicons/react/24/solid";

export default function CallDurationStats(props) {
  const { callDurationStats, isLoading } = props;

  return (
    <>
      <StatCard
        label="Total Call Duration"
        value={formatDurationToMinutesAndSeconds(
          Math.floor(callDurationStats?.total ?? 0)
        )}
        icon={<ClockIcon className="size-6 text-gray-500" />}
        isLoading={isLoading}
      />
      <StatCard
        label="Average Call Duration"
        value={formatDurationToHoursMinutesAndSeconds(
          Math.floor(callDurationStats?.average ?? 0)
        )}
        icon={<ChartPieIcon className="size-6 text-gray-500" />}
        isLoading={isLoading}
      />
    </>
  );
}
